import { createRouter, createWebHistory } from 'vue-router'
import HOME from "@/view/Home/home.vue"
//导入pinia
// import { useNewpageData } from "../stroe/pinia";

// 定义PC端路由数组
const routes: Array<any> = [
    //全匹配
    {
        path: "/",
        // 重定向
        redirect: "/Login"
    },
    //登录页
    {
        path: "/Login",
        component: () => import('@/view/Login/Login.vue')
    },
    //我要推广
    {
        path: "/Homepage",
        component: HOME,
        redirect: "/onhome",
        children: [
            {
                path: '/onhome',
                component: () => import('@/view/onhome/onhome.vue')
            },
            {
                path: '/System/AccountForm',
                component: () => import('@/view/System/AccountForm.vue')
            },
            {
                path: '/Listproducts/detail',
                component: () => import('@/view/Listproducts/Listproductsdetail.vue')
            },

        ]
    },
    //通知列表
    {
        path: "/notice",
        component: HOME,
        redirect: "/noticepage",
        children: [
            {
                path: '/noticepage',
                component: () => import('@/view/Notice/notice.vue')
            },
        ]
    },


    //订单详情
    {
        path: "/Order",
        component: HOME,
        redirect: "/Orderlist",
        children: [
            {
                path: '/Orderlist',
                component: () => import('@/view/Orderlist/Orderlist.vue'),

            },
            {
                path: '/Orderlistviewer',
                component: () => import('@/view/Orderlist/viewer.vue'),
            },

        ]
    },
    //我要推广
    {
        path: "/Listpage",
        component: HOME,
        redirect: "/Listproducts",
        children: [
            {
                path: '/Listproducts',
                component: () => import('@/view/Listproducts/Listproducts.vue')
            },
            {
                path: '/Promotional_detail',
                component: () => import('@/view/Listproducts/Listproductsdetail.vue')

            },
            // 推广学院
            {
                path: '/Promotionadd',
                component: () => import('../view/Listproducts/add.vue')
            },
            //教程学院
            {
                path: '/Promotionacademy',
                component: () => import('@/view/Listproducts/edit.vue')
            },
            //faqs
            {
                path: '/Promotionfaqs',
                component: () => import('@/view/Listproducts/faqs.vue')
            },

        ]
    },
    //推广管理
    {
        path: "/Promotion",
        component: HOME,
        redirect: "/Promotion_management",
        children: [
            {
                path: '/Promotion_management',
                component: () => import('@/view/Financial_management/Financial_management.vue')
            },

            {
                path: '/Promotional_list',
                component: () => import('@/view/Financial_management/InventoryList.vue')
            },
        ]
    },

    //个人中心
    {
        path: "/Personalcenter",
        component: HOME,
        redirect: "PersonalInformation",
        children: [
            {
                path: '/PersonalInformation',
                component: () => import('@/view/System/AccountForm.vue')
            },
            {
                path: '/mesge',
                component: () => import('@/view/System/mesge.vue')
            },
            {
                path: '/mesgedeteli',
                component: () => import('@/view/System/mesgedeteli.vue')
            }, {
                path: '/rixchtext',
                component: () => import('@/view/System/rixchtext.vue')
            }
        ]
    },
    // 分页器组件演示页面
    {
        path: "/PaginationDemo",
        component: HOME,
        redirect: "/pagination-demo",
        children: [
            {
                path: '/pagination-demo',
                component: () => import('@/views/PaginationDemo.vue')
            },
        ]
    },
    // 404页面
    {
        path: "/404",
        component: () => import('@/view/NotFound/NotFound.vue')
    },
    // 捕获所有未匹配的路由
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404"
    }
]
//环境变量处理 路由
const getRouterBase = () => {
    const env = import.meta.env.VITE_ENV || import.meta.env.MODE
    console.log('路由环境变量', env);
    switch (env) {
        case 'production':
            return '/'
        case 'test':
            return '/web/flkplatform/'
        case 'development':
            return '/'  // 开发环境构建使用根路径，便于预览
        default:
            return '/'
    }
}

// 创建一个路由实例对象
const router = createRouter({
    history: createWebHistory(getRouterBase()),
    routes: routes
})

// 检查token是否有效的函数
const isTokenValid = (token: string | null): boolean => {
    if (!token) return false

    try {
        // 检查token是否为空字符串或者只包含空白字符
        if (token.trim() === '') return false

        // 可以在这里添加更多的token验证逻辑
        // 比如检查token格式、过期时间等

        return true
    } catch (error) {
        console.error('Token验证出错:', error)
        return false
    }
}

// 添加路由守卫
router.beforeEach((to, _from, next) => {
    // 获取本地存储的token（项目中使用的是usetoken）
    const token = localStorage.getItem('usetoken')

    // 不需要登录的页面路径
    const publicPages = ['/Login', '/404']

    // 检查当前路由是否为公开页面
    const isPublicPage = publicPages.some(page => to.path === page)

    // 如果是公开页面，直接通过
    if (isPublicPage) {
        next()
        return
    }

    // 如果不是公开页面，检查token是否有效
    if (!isTokenValid(token)) {
        // token无效，清除可能存在的无效token
        localStorage.removeItem('usetoken')
        localStorage.removeItem('userinfo')
        localStorage.removeItem('uid')
        // 跳转到登录页面
        next('/Login')
        return
    }

    // token有效，正常通过
    next()
})

// 导出创建好的实例对象
export default router
